module.exports = "./img/ab8f37e859522391468ede2d7e4accd4.png";